/**
 * 用户会话管理工具
 * 在没有用户系统的情况下，使用浏览器会话和本地存储来区分用户
 */

// 生成唯一的会话ID
const generateSessionId = () => {
  return 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
};

// 获取或创建用户会话ID
export const getUserSessionId = () => {
  let sessionId = localStorage.getItem('user_session_id');
  
  if (!sessionId) {
    sessionId = generateSessionId();
    localStorage.setItem('user_session_id', sessionId);
    console.log('🆔 创建新的用户会话ID:', sessionId);
  } else {
    console.log('🆔 使用现有用户会话ID:', sessionId);
  }
  
  return sessionId;
};

// 清除用户会话（用于测试或重置）
export const clearUserSession = () => {
  localStorage.removeItem('user_session_id');
  console.log('🗑️ 清除用户会话ID');
};

// 获取用户标识（用于API调用）
export const getUserIdentifier = () => {
  const sessionId = getUserSessionId();
  // 可以基于会话ID生成一个数字ID，或者直接使用会话ID
  return sessionId;
};

// 检查是否为同一用户会话
export const isSameUserSession = (sessionId1, sessionId2) => {
  return sessionId1 === sessionId2;
};
